import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAuthenticated: false,
  profile: null,
};

export const authSlice = createSlice({
  name: "counter",
  initialState,
  reducers: {
    setAuth: (state, action) => {
      state.isAuthenticated = action.payload;
    },
    setProfile: (state, action) => {
      state.profile = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setAuth, setProfile, setRole } = authSlice.actions;

export default authSlice.reducer;
